<template>
  <div v-if="userInfo">
    <div class="user-section">
      <van-image lazy-load class="bg" width="100%" height="100%" :src="require('@/static/user-bg.jpg') "></van-image>
      <span class="bg-upload-btn yticon icon-paizhao"></span>
      <div class="portrait-box">
        <van-image lazy-load
          round
          width="100"
          height="100"
          class="portrait"
          :src="userInfo.avatar || require('@/static/missing-face.png')"
        ></van-image>
        <span class="pt-upload-btn yticon icon-paizhao"></span>
      </div>
      <div class="portrait-box" style="postion">
        <input
          class="portrait"
          style="opacity: 0;"
          type="file"
          name="file"
          @change="addImage"
          ref="inputer"
          accept="image/png, image/jpeg, image/jpg"
        />
        <span class="pt-upload-btn yticon icon-paizhao"></span>
      </div>
    </div>
    <div class="content">
      <div class="rowTab b-b">
        <span class="tit">昵称</span>
        <input
          class="input"
          type="span"
          v-model="userInfo.nickname"
          placeholder="请输入您的昵称"
          placeholder-class="placeholder"
        />
      </div>
      <div class="rowTab b-b">
        <span class="tit">手机号</span>
        <input
          class="input"
          type="span"
          v-model="userInfo.phone"
          placeholder="请输入您的手机号"
          placeholder-class="placeholder"
        />
      </div>
      <div class="rowTab b-b" @click="handleShowPicker" v-if="sexArr[userInfo.sex]">
        <span class="tit">性别</span>
        <input
          disabled
          class="input"
          type="span"
          :value="sexArr[userInfo.sex].text"
          placeholder="请选择性别"
          placeholder-class="placeholder"
        />
      </div>
      <van-popup v-model="showPicker" position="bottom" :style="{ height: '30%' }">
        <van-picker
          show-toolbar
          title="性别"
          :columns="sexArr"
          :default-index="userInfo.sex"
          @confirm="pickerChange"
          @cancel="handleShowPicker"
        />
      </van-popup>
    </div>
    <div class="add-btn" @click="confirm">保存</div>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
} from 'vuex';
export default {
  data () {
    return {
      userInfo: {},
      sexArr: [{
        value: 0,
        text: '未知'
      }, {
        value: 1,
        text: '男'
      }, {
        value: 2,
        text: '女'
      }],
      showPicker: false,
      fileList: [
        {
          url: 'https://img.yzcdn.cn/vant/tree.jpg',
          status: '',
          message: '',
        }
      ]
    };
  },
  created () {
    this.userInfo = JSON.parse(JSON.stringify(this.$store.getters.userInfo))
  },
  computed: {
    // userInfo(){
    // 	let userInfo = JSON.parse(JSON.stringify(this.$store.getters.userInfo))
    // 	return userInfo
    // },
  },
  methods: {
    ...mapMutations(['login']),
    addImage () {
      let inputDOM = this.$refs.inputer;
      let files = inputDOM.files;
      let that = this
      if (files.length > 0) {
        let file = files[0]
        that.$http.upload(file).then(res => {
          let data = res.data
          that.userInfo.avatar = data
          that.$set(that.userInfo, 'avatar', data)
        })
      }
    },
    handleShowPicker () {
      this.showPicker = !this.showPicker
    },
    pickerChange (e) {
      this.userInfo.sex = e.value
      this.handleShowPicker()
    },
    confirm () {
      if (!this.userInfo.nickname) {
        this.$toast('请输入昵称')
        return;
      }
      if (this.userInfo.sex == 0) {
        this.$toast('请选择性别')
        return;
      }
      this.$http.request(this.$http.pathMap.userSave, 'post', this.userInfo).then(res => {
        this.$toast('保存成功')
        this.login(this.userInfo)
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.user-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 230px;
  padding: 20px 15px 0;
  position: relative;

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    filter: blur(1px);
  }

  .portrait-box {
    width: 106px;
    height: 106px;
    border: 3px solid #fff;
    border-radius: 50%;
    position: absolute;
    z-index: 2;
  }

  .portrait {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .yticon {
    position: absolute;
    line-height: 1;
    z-index: 5;
    font-size: 24px;
    color: #fff;
    padding: 2px 3px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.4);
  }

  .pt-upload-btn {
    right: 0;
    bottom: 5px;
  }

  .bg-upload-btn {
    right: 10px;
    bottom: 8px;
  }
}

.rowTab {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 15px;
  min-height: 55px;
  background: #fff;

  .tit {
    flex-shrink: 0;
    width: 60px;
    font-size: 15px;
    color: $font-color-dark;
  }

  .input {
    padding: 0 5px;
    flex: 1;
    font-size: 15px;
    color: $font-color-dark;
  }

  .spanarea {
    min-height: 22px;
  }

  .icon-shouhuodizhi {
    font-size: 18px;
    color: $font-color-light;
  }
}

.default-row {
  margin-top: 8px;

  .tit {
    flex: 1;
  }

  switch {
    transform: translateX(8px) scale(0.9);
  }
}

.add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 345px;
  height: 40px;
  margin: 30px auto;
  font-size: $uni-font-size-lg;
  color: white;
  background-color: $base-color;
  border-radius: 5px;
}
</style>
